(function () {
  if (window.__divanoAccordionMotion) return;
  window.__divanoAccordionMotion = true;

  var SELECTOR = 'details[data-divano-panel], details.divano-materials-accordion, details.divano-faq-accordion__row';
  var OPEN_MS = 240;
  var CLOSE_MS = 200;
  var EASE = 'cubic-bezier(0.22, 1, 0.36, 1)';
  var reduced = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };

  function bodyParts(details) {
    var parts = [];
    for (var el = details.firstElementChild; el; el = el.nextElementSibling) {
      if (el.tagName !== 'SUMMARY') parts.push(el);
    }
    return parts;
  }

  function finish(details) {
    var run = details.__divanoMotion;
    if (run) {
      run.anim.cancel();
      run.fades.forEach(function (a) { a.cancel(); });
    }
    details.__divanoMotion = null;
    details.style.overflow = '';
    details.style.boxSizing = '';
  }

  function closedHeight(details) {
    var summary = details.querySelector(':scope > summary');
    var cs = getComputedStyle(details);
    return summary.getBoundingClientRect().bottom - details.getBoundingClientRect().top
      + (parseFloat(cs.paddingBottom) || 0) + (parseFloat(cs.borderBottomWidth) || 0);
  }

  function keepInView(details) {
    var summary = details.querySelector(':scope > summary');
    if (!summary) return;
    var s = summary.getBoundingClientRect();
    var d = details.getBoundingClientRect();
    var vh = window.innerHeight || document.documentElement.clientHeight;
    if (s.top > vh * 0.6 && d.bottom > vh) {
      window.scrollBy({ top: s.top - vh * 0.25, behavior: reduced.matches ? 'auto' : 'smooth' });
    }
  }

  function animate(details, opening) {
    var from = details.getBoundingClientRect().height;
    finish(details);
    var to;
    if (opening) {
      details.open = true;
      to = details.getBoundingClientRect().height;
    } else {
      to = closedHeight(details);
    }
    details.style.boxSizing = 'border-box';
    details.style.overflow = 'hidden';

    var anim = details.animate(
      { height: [from + 'px', to + 'px'] },
      { duration: opening ? OPEN_MS : CLOSE_MS, easing: EASE }
    );
    var fades = opening
      ? bodyParts(details).map(function (el) {
          return el.animate({ opacity: [0, 1] }, { duration: OPEN_MS - 40, delay: 40, easing: 'ease-out', fill: 'backwards' });
        })
      : [];
    details.__divanoMotion = { anim: anim, fades: fades, opening: opening };

    anim.onfinish = function () {
      if (!opening) details.open = false;
      finish(details);
      if (opening) keepInView(details);
    };
  }

  document.addEventListener('click', function (event) {
    if (event.defaultPrevented) return;
    var target = event.target;
    if (!(target instanceof Element)) return;
    var summary = target.closest('summary');
    if (!summary) return;
    var details = summary.parentElement;
    if (!details || !details.matches(SELECTOR)) return;
    var control = target.closest('a, button, input, select, textarea');
    if (control && control !== summary && summary.contains(control)) return;

    if (reduced.matches || typeof details.animate !== 'function') {
      if (!details.open) requestAnimationFrame(function () { requestAnimationFrame(function () { if (details.open) keepInView(details); }); });
      return;
    }

    event.preventDefault();
    var run = details.__divanoMotion;
    var opening = run ? !run.opening : !details.open;
    requestAnimationFrame(function () { animate(details, opening); });
  });
})();
